import CircularProgress from '@mui/material/CircularProgress'
import Button from '@mui/material/Button'
import { observer } from 'mobx-react-lite'
import React, { useRef } from 'react'

export type ButtonWithProgressProps = {
   loading?: boolean | null
   icon?: React.ReactNode
   /**
    * @default 'end'
    */
   iconAndLoadingPosition?: 'start' | 'center' | 'end'
} & Omit<React.ComponentProps<typeof Button>, 'startIcon' | 'endIcon'>

export default observer(React.forwardRef(function ButtonWithProgress(props: ButtonWithProgressProps, ref) {

   const { loading, children, iconAndLoadingPosition = 'end', ...otherProps } = props
   const disabled = loading || otherProps.disabled

   let loadingChildren: React.ReactNode = null
   let iconChildren: React.ReactNode = null

   const buttonIconProps: React.ComponentProps<typeof Button> = {}

   if (loading) {
      if (iconAndLoadingPosition === 'start') {
         buttonIconProps.startIcon = <CircularProgress sx={{ m: 0, alignSelf: 'flex-start' }} size={20} />
      } else if (iconAndLoadingPosition === 'end') {
         buttonIconProps.endIcon = <CircularProgress sx={{ m: 0, alignSelf: 'flex-end' }} size={20} />
      } else {
         loadingChildren = <CircularProgress size={20} />
      }
   } else {
      if (iconAndLoadingPosition === 'start') {
         buttonIconProps.startIcon = props.icon
      } else if (iconAndLoadingPosition === 'end') {
         buttonIconProps.endIcon = props.icon
      } else {
         iconChildren = props.icon
      }
   }

   return (
      <Button
         ref={useRef<any>(ref)}
         {...otherProps}
         disabled={disabled}
         {...buttonIconProps}
      >
         {loadingChildren || iconChildren || children}
      </Button>
   )
}))
